// extracted by mini-css-extract-plugin
module.exports = {"chip":"SkillChip_chip__1POuq","chipStar":"SkillChip_chipStar__5FYCs","chipStarCell":"SkillChip_chipStarCell__2t_Pv","close":"SkillChip_close__26IaH"};